module.exports = __webpack_public_path__ + "img/slipmat-c.4069bcae.png";